module.exports = __webpack_public_path__ + "static/media/pdf.dcd7d659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf.png
// module id = 220
// module chunks = 0